import { appFeature } from 'modules/organizer/domain/interfaces/available-feature';
import { useGetAvailableFeaturesQuery } from 'modules/organizer/store/available-features-api';

/**
 * Фича тарифа **названной** организации, а не активной в шапке (IMGM-1520).
 *
 * Отдельный хук, а не опция `useFeature`: тот живёт на активной организации у меню и роутов, и
 * супер-админу там открыто всё. Здесь исключения для супер-админа нет — экран чужой организации
 * (вкладка «Медиа» турнира) делает то, что бэкенд проверяет по тарифу именно этой организации, и
 * супер-админу он откажет так же, как админу.
 *
 * `isFetching` — «данных для этой организации ещё нет», как в `useFetchAvailableFeature`: фоновый
 * перезапрос после оплаты его не поднимает, и экран не мигает пустотой. Ошибка запроса — фичи нет.
 *
 * @param organizerId id организации (backend `tournamentId`); `0` — запроса нет, фичи нет.
 */
export function useOrganizerFeature(organizerId: number, feature: appFeature) {
  const skip = !organizerId;
  const query = useGetAvailableFeaturesQuery(organizerId, { skip });
  // `currentData`, а не `data`: при смене организации `data` ещё держит фичи прежней.
  const data = query.currentData;

  return {
    isEnabled: data?.[feature] ?? false,
    isFetching: !skip && data === undefined && query.isFetching,
  };
}
